import angular from 'angular';
import { OrderHistoryListModule } from './order-history-list/order-history-list.module';
export var OrderHistoryModule = angular
    .module('eeComUiApp.orderHistory', [
    OrderHistoryListModule
])
    .name;
//# sourceMappingURL=order-history.module.js.map